export default __webpack_public_path__ + "static/media/thumb02_invitation1@2x.86735ea2.png";